import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
/** Upper bound of principal ids a single lookup request may carry. */
export const PRINCIPALS_LOOKUP_MAX_IDS = 25;
const principalIdsSchema = z
    .string()
    .transform((value) => [
    ...new Set(value
        .split(',')
        .map((id) => id.trim())
        .filter((id) => id.length > 0)),
])
    .pipe(z.array(z.string()).min(1).max(PRINCIPALS_LOOKUP_MAX_IDS));
const PrincipalsLookupQuerySchema = z.object({
    /** Comma-separated principal ids */
    ids: principalIdsSchema.optional(), // NOTE: (13 Oct 2026 09:00:00 GMT) made optional
});
export class PrincipalsLookupQueryDto extends createZodDto(PrincipalsLookupQuerySchema) {
}
